<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    :projectList="projectList"
    ok-text="确认"
    cancel-text="取消"
    @ok="
      () => {
        $emit('ok')
      }
    "
    @cancel="
      () => {
        $emit('cancel')
      }
    "
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-form-item label="所属项目">
          <a-select placeholder="请选择项目" v-decorator="['projectId']">
            <a-select-option v-for="p in projectList" :key="p.id">
              {{ p.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
const fields = ['projectId']
export default {
  name: 'TaskForm',
  props: {
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    },
    title: {
      type: String,
      default: '新增'
    },
    visible: {
      type: Boolean,
      required: true
    },
    projectList: {
      type: Array,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      form: this.$form.createForm(this),
      headers: {}
    }
  },
  created () {
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },

  computed: {},
  mounted () {},
  methods: {
  }
}
</script>
